@if (savingACHSetUpChange) {
  <mat-progress-bar
    mode="indeterminate"
  ></mat-progress-bar>
}
<mat-tab-group>
  <mat-tab label="Signed ACH Records">
    <table
      mat-table
      [dataSource]="achRecords"
      class="mat-elevation-z8 width-100"
      >
      <ng-container matColumnDef="User">
        <th mat-header-cell *matHeaderCellDef>User</th>

        <td mat-cell *matCellDef="let element">
          {{ element.userModel.firstName }}
          {{ element.userModel.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Date Signed">
        <th mat-header-cell *matHeaderCellDef>Date Signed</th>

        <td mat-cell *matCellDef="let element">
          @if (element.contractModel.dateSigned) {
            <div>
              {{ element.contractModel.dateSigned | date:'medium'}}
            </div>
          }

          @if (!element.contractModel.dateSigned) {
            <div>N/A</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="Setup Complete">
        <th mat-header-cell *matHeaderCellDef>Set up Complete</th>

        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            class="example-margin"
            [checked]="element.setupComplete"
            (change)="changeUpdateStatus(element)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="Details">
        <th mat-header-cell *matHeaderCellDef>Details</th>

        <td mat-cell *matCellDef="let element">
          <mat-icon
            class="clickable"
            (click)="openDetailsDialog(element)"
            >launch</mat-icon
            >
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="signedDisplayedColumns"></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: signedDisplayedColumns"
        ></tr>
      </table>
    </mat-tab>

    <mat-tab label="Need Signed">
      <table
        mat-table
        [dataSource]="unsignedACHContracts"
        class="mat-elevation-z8 width-100"
        >
        <ng-container matColumnDef="User">
          <th mat-header-cell *matHeaderCellDef>User</th>

          <td mat-cell *matCellDef="let element">
            @if (element.applicationModel != null) {
              <div>
                {{ element.applicationModel.userModel.firstName }}
                {{ element.applicationModel.userModel.lastName }}
              </div>
            }

            @if (element.applicationModel == null) {
              <div>
                No Application Attached to Contract
              </div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="Email Address">
          <th mat-header-cell *matHeaderCellDef>Email Address</th>

          <td mat-cell *matCellDef="let element">
            @if (element.applicationModel != null) {
              <div>
                {{ element.applicationModel.userModel.emailAddress }}
              </div>
            }
            @if (element.applicationModel == null) {
              <div>
                No Application Attached to Contract
              </div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="Contract Create Date">
          <th mat-header-cell *matHeaderCellDef>Contract Create Date</th>

          <td mat-cell *matCellDef="let element">
            {{ element.createDateUTC | date:'medium' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="unsignedDisplayedColumns"></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: unsignedDisplayedColumns"
        ></tr>
      </table>
    </mat-tab>
  </mat-tab-group>
